import React from 'react';
import styles from '../CartItemsTable.scss';

export default class TableItemQuantity extends React.Component {
  onChange (q, oDI, e) {
    if (q < 1) {
      return false;
    }
    this.props.onChange(q, oDI);
  }

  onInputChange = (e) => {
    e.preventDefault();
    this.onChange(+e.target.value, this.props.cartDetailId);
  };

  render() {
    const {quantity, cartDetailId} = this.props;
    return (
      <div className={styles.itemQuantityBlock}>
        <button
          className={styles.minusBtn}
          onClick={this.onChange.bind(this, quantity - 1, cartDetailId)}>
          <div />
        </button>
        <input
          type="number"
          onChange={this.onInputChange}
          className={styles.itemQuantityIndicator}
          value={quantity}
          />
          <button
          className={styles.plusBtn}
          onClick={this.onChange.bind(this, quantity + 1, cartDetailId)}>
          <div />
          <div />
        </button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/CartPage/elements/tableElements/TableItemQuantity.jsx
 **/